// extracted by mini-css-extract-plugin
export default {"linkStyle":"customBreadcrumbs_linkStyle__6HMqN","currentPageText":"customBreadcrumbs_currentPageText__itjLd"};